import React from "react";

import { cn } from "~/components/ui/cn";

export const InputContainer: React.FC<React.ComponentProps<"div">> = ({
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        "relative w-full text-gray-500 transition-colors focus-within:text-gray-900",
        className,
      )}
      {...props}
    ></div>
  );
};

InputContainer.displayName = "InputContainer";
